export default "__VITE_ASSET__C00b8Xp4__"